import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DynamicDataResponse} from '../model/dynamicData/dynamicDataResponse';
import {ProjectService} from '../project/project.service';
import {DynamicDataRequestConfig} from '../model/dynamicData/dynamicDataRequestConfig';
import {RespondentIdentification} from '../model/dynamicData/respondentIdentification';
import {SearchStrategy} from '../model/dynamicData/searchStrategy';
import {DynamicValueFilter} from '../model/dynamicData/dynamicValueFilter';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {DynamicData} from '../model/dynamicData/dynamicData';
import {DynamicDataFilterComponent} from '../dynamicDataFilter/dynamic-data-filter.component';

@Component({
    selector:'dynamicData',
    template:`
        <div class="card col-md-12" >
                <div class="panel panel-primary col-md-12">
                        <div class="panel-heading">
                            <h3 class="panel-title">Dynamic Data</h3>
                        </div>
                    <button class="btn btn-primary" (click)="openFilter()">Dynamic data value filter</button>
                    <dynamicDataFilter [dynamicDataRequestConfig]="dynamic" (refreshDynamicData) = "refreshDynamicData($event)"></dynamicDataFilter>
                    <loadingCircles *ngIf="_isLoading"></loadingCircles>
                    <h4 *ngIf="(dynamicDataResponse!=null || dynamicDataResponse==null)  && !_isLoading"> No Dynamic Data Is Available! Try using the above filter for better results.</h4>
                    <div class="panel-body" *ngIf="dynamicDataResponse!=null && dynamicDataResponse._dynamic_values_list.length!==0">
                                <div class="container tableFixHead">
                                    <table class="table">
                                        <thead class="tableHeader">
                                        <tr>
                                            <th>Date Created</th>
                                            <th>UEI</th>
                                            <th>Data Key</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <ng-container *ngIf="dynamicDataResponse!=null">
                                            <tr class="entries" *ngFor="let item of dynamicDataResponse._dynamic_values_list" (click)="onDynamicHeaderSelected(item)">
                                                <td>{{item.date_created}}</td>
                                                <td>{{item.UEI}}</td>
                                                <td>{{item.data_key}}</td>
                                            </tr>
                                        </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="container dataValues">
                                    <div>Data Values</div>
                                    <ng-container *ngIf="selectedDynamicData!=null && dynamicDataResponse!=null">
                                        <div class="entry" *ngFor="let item of this.selectedDynamicData.data_values">
                                            <div>{{item}}</div>

                                            <div><ng-container *ngIf="ifMedia(item)"><div><button class="btn btn-outline-primary" (click)="onViewClick(item)"><img style="height:18px;" alt="icon" src="../../assets/images/eyeIcon.png"></button></div></ng-container></div>
                                        </div>
                                    </ng-container>
                                </div>
                    </div>
            </div>
        </div>
    <imageViewer *ngIf="_contentToView!=''" [answer]="_contentToView"></imageViewer>`,
    styles:[`.container {
        margin: 50px auto 0;
        width: 780px;
        height: 675px;
        background: #f5f5f5;
        padding: 30px;
        border-radius: 5px;
        border: solid 2px #777;
        box-shadow: 0 0 5px #333;
        margin-bottom: 10%;
        float:left;
    }
    .tableFixHead {
        overflow-y: auto;
    }

    th,td {text-align: center;}


    .dataValues{width:300px; overflow-y: auto;margin-left: 5px;}
    .entry{ border-style: dashed; border-color: #1c71ff; border-width: 1px; border-radius: 3px;}
    .entry:hover{color: white; background-color: #1b1e21;}
    .entries:hover{ background-color: #1b1e21;color: white;}
    .panel-body{width: max-content}

    .modal-title{margin-top: -5px;}
    .closeBtnH4{margin-top:-5px;margin-right: -8px;}
    .appWindow {
        height: 35px;
    }
    .clientRow{background-color: #D0DFFE;}

    .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
    th{color:#ffffff;text-align: center;}

    .modalBodyContainer{
        padding-left: 3px;
        padding-right: 3px;
    }

    .modal-footer{background-color: #ECE8E5;}
    .modal-body {
        width: 100%;
        padding: 0;
        overflow-y: auto;
        height: 700px;
    }
    .modal-body thead {
        position: sticky;
        top:0;
    }
    ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
    }
    ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
    }
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    .modal-dialog {
        max-width: 1200px;
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-header {
        height:56px;
    //background-color: #0064FE;
        background-image: url("../../assets/images/blueBack.jpg");
        color: antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-content {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        background-color: #0064FE;
        padding-bottom: 3px;
    }

    .closeX {
        color: white;
        size: 25px;
    }

    .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
    }

    /* .btn-outline-danger:hover {
         width: 32px;
         background-image: url("../../../assets/images/closeBtnHovered.png");
     }*/

    .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

    .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}

    .btn-success {
        background-color: #08780C;

        border-style: solid;
        border-color: white;
        border-width: 2px;
    }

    .modOK{ background-image: url("../../assets/images/290x24x24.png");background-repeat: no-repeat;}

    .btn-success:hover {
        background-color: #0CAF10;
    }

    .btn-warning {
        background-color: #F1C829;
        border-style: solid;
        border-color: white;
        border-width: 2px;
    }

    .btn-warning:hover {
        background-color: #F7DD77;
    }`]
})
export class DynamicDataComponent implements OnInit {

   private hide = true;

   @Input() token = '';

   @Input() fromDate = '';

   @Input() toDate = '';

   private dynamic = new DynamicDataRequestConfig();

   private selectedDynamicData:DynamicData = null;

   private dynamicDataResponse:DynamicDataResponse = new DynamicDataResponse();

   private _isLoading = false;

   private _contentToView = '';

   @ViewChild
   (DynamicDataFilterComponent) private dynamicDataFilterComponent:DynamicDataFilterComponent;

   constructor(private _projectService: ProjectService) {
   }

    toggleDialog() {
        this.hide  = !this.hide;
    }

    ngOnInit(): void {
        const respondent_identification = new RespondentIdentification();
        const searchStrategy = new SearchStrategy();

        searchStrategy.token = this.token;

        searchStrategy.searchStrategy = 'Token';
        respondent_identification.search_strategy = searchStrategy;
        this.dynamic.respondent_identification = respondent_identification;
        this.dynamic.dynamic_values_filter =  new DynamicValueFilter();
        // dynamic.dynamic_values_filter.keys_filter.push('');
        this.dynamic.dynamic_values_filter.min_date = '2021-02-23T02:15:12-05:00';
        this.dynamic.dynamic_values_filter.max_date = '2021-05-26T02:15:12-05:00';

        this.getDynamicData(this.dynamic);
    }


    getDynamicData(dynamic:DynamicDataRequestConfig) {
        this._isLoading = true;
        this._projectService.getDynamicData(dynamic).subscribe((val)=> {
            console.log(val);
            this.dynamicDataResponse = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(val,DynamicDataResponse);
            this._isLoading = false;
        });
    }

    onDynamicHeaderSelected(item: DynamicData) {
        this.selectedDynamicData = item;
    }

    refreshDynamicData(val:DynamicDataRequestConfig) {
        this.getDynamicData(val);
    }

    openFilter() {
        this.dynamicDataFilterComponent.toggleFilter();
    }

    ifMedia(item: String) {
        if(item.includes('vimeo') || item.includes('file')) {
            return true;
        }
        return false;
    }

    onViewClick(item: string) {
        this._contentToView = item;
    }
}
